import React, { useEffect, useState, useRef } from "react";
import { Backdrop, Box } from "@mui/material";
import loaderImg from "../../../assets/svgs/xlr8_logo_small.svg";

interface LoaderProps {
  isLoading: boolean;
  zIndex?: number;
  isAbsolute?: boolean;
  radius?: { top: number; right: number; bottom: number; left: number };
}

const Loader = ({
  isLoading,
  zIndex,
  isAbsolute,
  radius = { top: 0, right: 0, bottom: 0, left: 0 },
}: LoaderProps) => {
  const [showLoader, setShowLoader] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (isLoading) {
      // Clear any pending timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setShowLoader(true);
    } else {
      // Delay hiding the loader
      timeoutRef.current = setTimeout(() => {
        setShowLoader(false);
        timeoutRef.current = null;
      }, 100);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isLoading]);
  return (
    <Backdrop
      sx={{
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        zIndex: (theme) => (zIndex ? zIndex : theme.zIndex.drawer + 1),
        position: isAbsolute ? "absolute" : "fixed",
        ...(radius && {
          borderRadius: `${radius.top}px ${radius.right}px ${radius.bottom}px ${radius.left}px`,
        }),
      }}
      open={showLoader}
    >
      <Box className="loaderContainer">
        <Box className="loaderImg" component="img" src={loaderImg} />
        <Box className="loader">
          <Box className="dot"></Box>
          <Box className="dot"></Box>
          <Box className="dot"></Box>
        </Box>
      </Box>
    </Backdrop>
  );
};

export default Loader;
